/* ============================================================
   ROCCOPE SHOPIFY THEME — theme.js
   Vanilla JS: header, mobile menu, search, cart, gallery,
               quick-add, wishlist, FAQ, newsletter, toast
   ============================================================ */

(function () {
  'use strict';

  /* =====================================================
     UTILITIES
     ===================================================== */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* =====================================================
     TOAST NOTIFICATIONS
     ===================================================== */
  var toastContainer;
  function initToasts() {
    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }
  function showToast(msg, type) {
    if (!toastContainer) return;
    var t = document.createElement('div');
    t.className = 'toast toast-' + (type || 'success');
    t.textContent = msg;
    toastContainer.appendChild(t);
    setTimeout(function () {
      t.style.opacity = '0';
      t.style.transition = 'opacity 0.3s';
      setTimeout(function () { t.remove(); }, 300);
    }, 3000);
  }

  /* =====================================================
     HEADER SCROLL BEHAVIOUR
     ===================================================== */
  function initHeader() {
    var header = qs('.site-header');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* =====================================================
     MOBILE MENU
     ===================================================== */
  function initMobileMenu() {
    var overlay  = qs('.mobile-menu-overlay');
    var openBtn  = qs('.mobile-menu-btn');
    var closeBtn = qs('.mobile-menu-close');
    var backdrop = qs('.mobile-menu-backdrop');
    if (!overlay) return;
    function open()  { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('open'); document.body.style.overflow = ''; }
    on(openBtn,  'click', open);
    on(closeBtn, 'click', close);
    on(backdrop, 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* =====================================================
     SEARCH MODAL
     ===================================================== */
  function initSearchModal() {
    var modal    = qs('.search-modal');
    var openBtns = qsa('[data-search-open]');
    var closeBtn = qs('[data-search-close]');
    var input    = qs('.search-modal-input');
    var results  = qs('.search-modal-results');
    if (!modal) return;

    function open() {
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(function () { input.focus(); }, 100);
    }
    function close() {
      modal.classList.remove('open');
      document.body.style.overflow = '';
      if (input) input.value = '';
      if (results) results.innerHTML = '';
    }

    openBtns.forEach(function (btn) { on(btn, 'click', open); });
    on(closeBtn, 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });

    // Live search
    var searchTimer;
    on(input, 'input', function () {
      clearTimeout(searchTimer);
      var q = input.value.trim();
      if (q.length < 2) { if (results) results.innerHTML = ''; return; }
      searchTimer = setTimeout(function () { doSearch(q); }, 300);
    });

    function doSearch(q) {
      if (!results) return;
      var msgSearching  = modal.getAttribute('data-msg-searching')  || 'Searching…';
      var msgNoResults  = modal.getAttribute('data-msg-no-results')  || 'No results for';
      var msgError      = modal.getAttribute('data-msg-error')       || 'Something went wrong.';
      var locale        = modal.getAttribute('data-locale') || 'en';
      var isPrimary     = modal.getAttribute('data-locale-primary') === 'true';
      var localePrefix  = isPrimary ? '' : '/' + locale;
      results.innerHTML = '<p style="font-family:var(--font-body);color:var(--brand);opacity:.5;padding:1rem 0">' + msgSearching + '</p>';
      fetch(localePrefix + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<p style="font-family:var(--font-body);color:var(--brand);opacity:.5;padding:1rem 0">' + msgNoResults + ' &ldquo;' + q + '&rdquo;</p>';
            return;
          }
          results.innerHTML = products.map(function (p) {
            var imgSrc = p.image ? p.image : '';
            return '<a href="' + p.url + '" style="display:flex;gap:1rem;align-items:center;padding:1rem 0;border-bottom:1px solid rgba(63,28,7,.08);text-decoration:none">' +
              (imgSrc ? '<img src="' + imgSrc + '" style="width:4rem;height:5rem;object-fit:cover;flex-shrink:0">' : '') +
              '<div><p style="font-family:var(--font-display);font-size:1.125rem;font-weight:300;color:var(--brand)">' + p.title + '</p>' +
              '<p style="font-family:var(--font-body);font-size:.8125rem;color:rgba(63,28,7,.6)">' + (p.price ? '₹' + (p.price / 100).toFixed(2) : '') + '</p></div></a>';
          }).join('');
        })
        .catch(function () {
          if (results) results.innerHTML = '<p style="font-family:var(--font-body);color:var(--brand);opacity:.5;padding:1rem 0">' + msgError + '</p>';
        });
    }
  }

  /* =====================================================
     HERO BANNER SLIDER
     ===================================================== */
  function initHeroSlider() {
    var slides    = qsa('.hero-slide');
    var indicators= qsa('.hero-indicator');
    if (slides.length <= 1) return;
    var current = 0;
    var timer;

    function goTo(idx) {
      slides[current].classList.remove('active');
      indicators[current] && indicators[current].classList.replace('active-dot', 'inactive');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('active');
      indicators[current] && indicators[current].classList.replace('inactive', 'active-dot');
    }

    function start() { timer = setInterval(function () { goTo(current + 1); }, 6000); }
    function stop()  { clearInterval(timer); }

    indicators.forEach(function (btn, i) {
      on(btn, 'click', function () { stop(); goTo(i); start(); });
    });

    slides[0].classList.add('active');
    indicators[0] && indicators[0].classList.replace('inactive', 'active-dot');
    start();
  }

  /* =====================================================
     SCROLL REVEAL
     ===================================================== */
  function initReveal() {
    var els = qsa('.reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* =====================================================
     PRODUCT IMAGE GALLERY
     ===================================================== */
  function initProductGallery() {
    var thumbs  = qsa('.product-thumb');
    var imgs    = qsa('.product-main-image img');
    if (!thumbs.length || !imgs.length) return;

    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        imgs.forEach(function (img) { img.classList.add('hidden'); });
        thumb.classList.add('active');
        if (imgs[i]) imgs[i].classList.remove('hidden');
      });
    });
  }

  /* =====================================================
     QUANTITY STEPPER
     ===================================================== */
  function initQuantitySteppers() {
    qsa('.quantity-selector').forEach(function (sel) {
      if (sel.hasAttribute('data-cart-qty')) return;
      var minus = qs('.qty-btn[data-action="minus"]', sel);
      var plus  = qs('.qty-btn[data-action="plus"]',  sel);
      var val   = qs('.qty-value', sel);
      if (!minus || !plus || !val) return;
      var max = parseInt(sel.dataset.max || '99', 10);

      on(minus, 'click', function () {
        var v = parseInt(val.textContent, 10);
        if (v > 1) val.textContent = v - 1;
        minus.disabled = parseInt(val.textContent, 10) <= 1;
        updateHiddenQty(sel, parseInt(val.textContent, 10));
      });
      on(plus, 'click', function () {
        var v = parseInt(val.textContent, 10);
        if (v < max) val.textContent = v + 1;
        plus.disabled = parseInt(val.textContent, 10) >= max;
        updateHiddenQty(sel, parseInt(val.textContent, 10));
      });
    });
  }
  function updateHiddenQty(sel, v) {
    var input = qs('input[name="quantity"]', sel.closest('form') || document);
    if (input) input.value = v;
  }

  /* =====================================================
     PRODUCT TABS (Description / Details)
     ===================================================== */
  function initProductTabs() {
    var nav = qs('.tab-nav');
    if (!nav) return;
    var btns   = qsa('.tab-btn',   nav);
    var panels = qsa('.tab-panel');

    btns.forEach(function (btn) {
      on(btn, 'click', function () {
        var target = btn.dataset.tab;
        btns.forEach(function (b) { b.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = qs('.tab-panel[data-tab="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* =====================================================
     FAQ ACCORDION
     ===================================================== */
  function initFAQ() {
    qsa('.faq-item').forEach(function (item) {
      var btn = qs('.faq-btn', item);
      on(btn, 'click', function () {
        var isOpen = item.classList.contains('open');
        // Close all
        qsa('.faq-item').forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
    // Open first by default
    var first = qs('.faq-item');
    if (first) first.classList.add('open');
  }

  /* =====================================================
     NEWSLETTER FORM
     ===================================================== */
  function initNewsletter() {
    qsa('.newsletter-form').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var input  = qs('.newsletter-input', form);
        var thanks = qs('.newsletter-thanks', form.parentElement);
        if (!input || !input.value) return;
        // Shopify's built-in newsletter uses /contact#contact_form
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ form_type: 'customer', 'contact[email]': input.value, utf8: '✓' }).toString()
        }).then(function () {
          form.style.display = 'none';
          if (thanks) thanks.style.display = 'block';
        }).catch(function () {
          form.style.display = 'none';
          if (thanks) thanks.style.display = 'block';
        });
      });
    });
  }

  /* =====================================================
     SHOPIFY AJAX CART
     ===================================================== */
  var cartCountEls = [];

  function getCartCountEls() {
    return qsa('[data-cart-count]');
  }

  function updateCartCount(count) {
    getCartCountEls().forEach(function (el) {
      el.textContent = count;
      var badge = el.closest('.cart-badge') || el;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(variantId, qty, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1, properties: properties || {} })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error adding to cart'); });
        return r.json();
      });
  }

  function initQuickAdd() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.quickAdd;
      if (!variantId) return;
      btn.disabled = true;
      btn.innerHTML = '<span class="spinner"></span>';

      addToCart(variantId, 1)
        .then(function () {
          btn.innerHTML = '✓ Added';
          showToast('Added to cart!', 'success');
          fetchCartCount();
          setTimeout(function () {
            btn.disabled = false;
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
          }, 2000);
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = 'Quick Add';
          showToast(err.message || 'Out of stock', 'error');
        });
    });
  }

  /* ---------- Product Detail Add-to-Cart ---------- */
  function initProductAddToCart() {
    var form = qs('form[action="/cart/add"]');
    if (!form) return;

    var addBtn = qs('[data-add-to-cart]', form);
    var buyBtn = qs('[data-buy-now]');

    on(form, 'submit', function (e) {
      e.preventDefault();
      if (!addBtn) return;
      addBtn.disabled = true;
      var orig = addBtn.innerHTML;
      addBtn.innerHTML = '<span class="spinner"></span>';

      var fd = new FormData(form);
      var variantId = fd.get('id');
      var qty       = parseInt(fd.get('quantity') || '1', 10);

      addToCart(variantId, qty)
        .then(function () {
          addBtn.innerHTML = '✓ Added';
          showToast('Added to cart!', 'success');
          fetchCartCount();
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.innerHTML = orig;
          }, 3000);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.innerHTML = orig;
          showToast(err.message, 'error');
        });
    });

    // Buy Now
    on(buyBtn, 'click', function () {
      if (!buyBtn) return;
      buyBtn.disabled = true;
      var orig = buyBtn.innerHTML;
      buyBtn.innerHTML = '<span class="spinner"></span>';
      var fd     = new FormData(form);
      var varId  = fd.get('id');
      var qty    = parseInt(fd.get('quantity') || '1', 10);

      addToCart(varId, qty)
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          buyBtn.disabled = false;
          buyBtn.innerHTML = orig;
          showToast(err.message, 'error');
        });
    });
  }

  /* ---------- Variant Selector ---------- */
  function initVariantSelector() {
    var selector = qs('[data-variant-selector]');
    if (!selector) return;
    var radios    = qsa('input[name="variant-id"]', selector);
    var priceEl   = qs('[data-product-price]');
    var comparePriceEl = qs('[data-compare-price]');
    var stockEl   = qs('[data-stock-indicator]');
    var mainImg   = qs('.product-main-image img');
    var hiddenId  = qs('input[name="id"]');

    radios.forEach(function (r) {
      on(r, 'change', function () {
        var price   = r.dataset.price;
        var compare = r.dataset.comparePrice;
        var stock   = parseInt(r.dataset.stock || '0', 10);
        var img     = r.dataset.image;

        if (hiddenId) hiddenId.value = r.value;
        if (priceEl && price) priceEl.textContent = price;
        if (comparePriceEl) {
          if (compare && compare !== price) {
            comparePriceEl.textContent = compare;
            comparePriceEl.style.display = 'inline';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (stockEl) {
          if (stock === 0) {
            stockEl.innerHTML = '<span class="stock-out">Out of stock</span>';
          } else if (stock <= 3) {
            stockEl.innerHTML = '<span class="stock-low">Only ' + stock + ' remaining</span>';
          } else {
            stockEl.innerHTML = '<span class="stock-in"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> In stock</span>';
          }
        }
        if (img && mainImg) mainImg.src = img;
      });
    });
  }

  /* =====================================================
     CART PAGE — QUANTITY UPDATE & REMOVE
     ===================================================== */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updateCartTotals(cart) {
    qsa('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    qsa('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    qsa('[data-cart-item-count]').forEach(function (el) {
      el.textContent = 'Subtotal (' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ')';
    });
    updateCartCount(cart.item_count);
  }

  function initCartPage() {
    on(document, 'click', function (e) {
      // Remove item
      var removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        var key = removeBtn.dataset.removeItem;
        removeBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { showToast('Could not remove item', 'error'); removeBtn.disabled = false; });
        return;
      }

      // Qty +/- buttons
      var clickedBtn  = e.target.closest('.qty-btn[data-action]');
      var qtySelector = e.target.closest('[data-cart-qty]');
      if (!clickedBtn || !qtySelector) return;

      var lineKey = qtySelector.dataset.key;
      var action  = clickedBtn.dataset.action;
      var valEl   = qs('.qty-value', qtySelector);
      var current = parseInt(valEl ? valEl.textContent : '1', 10);
      var newQty  = action === 'plus' ? current + 1 : Math.max(1, current - 1);
      if (newQty === current) return;

      clickedBtn.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (valEl) valEl.textContent = newQty;
          var minusBtn = qs('.qty-btn[data-action="minus"]', qtySelector);
          if (minusBtn) minusBtn.disabled = newQty <= 1;
          clickedBtn.disabled = false;

          // Update this line's price
          var updatedItem = cart.items.filter(function (i) { return i.key === lineKey; })[0];
          if (updatedItem) {
            var priceEl = qs('[data-line-price="' + lineKey + '"]');
            if (priceEl) priceEl.textContent = formatMoney(updatedItem.line_price);
          }

          updateCartTotals(cart);
        })
        .catch(function () {
          clickedBtn.disabled = false;
          showToast('Could not update cart', 'error');
        });
    });
  }

  /* =====================================================
     DISCOUNT CODE
     ===================================================== */
  function initDiscountCode() {
    var toggle      = qs('#discount-toggle');
    var form        = qs('#discount-form');
    var input       = qs('#discount-input');
    var applyBtn    = qs('#discount-apply');
    var msg         = qs('#discount-msg');
    var checkoutBtn = qs('#cart-checkout');
    if (!toggle || !form || !input || !applyBtn || !checkoutBtn) return;

    var savedCode = '';

    // Toggle open/close
    toggle.addEventListener('click', function () {
      var open = form.style.display === 'flex';
      form.style.display = open ? 'none' : 'flex';
      toggle.setAttribute('aria-expanded', String(!open));
    });

    // Apply button
    applyBtn.addEventListener('click', function () {
      var code = input.value.trim().toUpperCase();
      if (!code) {
        showMsg('Please enter a discount code.', '#b91c1c', '#fef2f2');
        return;
      }
      savedCode = code;
      checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(savedCode);
      showMsg('Code "' + savedCode + '" saved — discount will apply at checkout.', '#166534', '#f0fdf4');
      applyBtn.textContent = '✓ Applied';
      input.readOnly = true;
    });

    // Allow removing the code by clearing the input
    input.addEventListener('input', function () {
      if (input.readOnly) {
        input.readOnly = false;
        applyBtn.textContent = 'Apply';
        savedCode = '';
        checkoutBtn.href = '/checkout';
        if (msg) msg.style.display = 'none';
      }
    });

    function showMsg(text, color, bg) {
      if (!msg) return;
      msg.textContent = text;
      msg.style.color = color;
      msg.style.background = bg;
      msg.style.display = 'block';
    }
  }

  /* =====================================================
     LOCAL WISHLIST (localStorage)
     ===================================================== */
  var WISHLIST_KEY = 'roccope_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function isWishlisted(productId) {
    return getWishlist().some(function (item) { return item.productId === productId; });
  }

  function initWishlistButtons() {
    // Reflect saved state on static buttons
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var productId = btn.dataset.wishlistToggle;
      if (!productId) return;
      if (isWishlisted(productId)) btn.classList.add('wishlisted');
    });

    // Single delegated listener handles both static and dynamically rendered buttons
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var productId = btn.dataset.wishlistToggle;
      if (!productId) return;

      var list = getWishlist();
      if (isWishlisted(productId)) {
        saveWishlist(list.filter(function (i) { return i.productId !== productId; }));
        qsa('[data-wishlist-toggle="' + productId + '"]').forEach(function (b) { b.classList.remove('wishlisted'); });
        showToast('Removed from wishlist', 'success');

        // If on wishlist page, remove the card from DOM
        var card = btn.closest('.product-card, article[data-product-id], [data-wishlist-card]');
        if (card && window.location.pathname.indexOf('wishlist') !== -1) {
          card.remove();
          if (getWishlist().length === 0) {
            var grid = document.getElementById('wishlist-grid');
            var empty = document.getElementById('wishlist-empty');
            if (grid) grid.style.display = 'none';
            if (empty) empty.style.display = 'block';
          }
        }
      } else {
        list.push({
          productId: productId,
          title:     btn.dataset.productTitle || '',
          price:     btn.dataset.productPrice || '',
          image:     btn.dataset.productImage || '',
          url:       btn.dataset.productUrl   || ''
        });
        saveWishlist(list);
        qsa('[data-wishlist-toggle="' + productId + '"]').forEach(function (b) { b.classList.add('wishlisted'); });
        showToast('Added to wishlist', 'success');
      }
    });
  }

  /* =====================================================
     WISHLIST DRAWER
     ===================================================== */
  function buildWishlistDrawer() {
    var existing = document.getElementById('wishlist-drawer');
    if (existing) return;

    var drawer = document.createElement('div');
    drawer.id = 'wishlist-drawer';
    drawer.innerHTML =
      '<div class="wishlist-backdrop" id="wishlist-backdrop"></div>' +
      '<div class="wishlist-panel">' +
        '<div class="wishlist-panel-head">' +
          '<span class="wishlist-panel-title">Wishlist</span>' +
          '<button class="wishlist-panel-close header-icon-btn" id="wishlist-close" aria-label="Close wishlist">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="wishlist-panel-body" id="wishlist-panel-body"></div>' +
      '</div>';
    document.body.appendChild(drawer);

    on(document.getElementById('wishlist-close'),   'click', closeWishlistDrawer);
    on(document.getElementById('wishlist-backdrop'), 'click', closeWishlistDrawer);
  }

  function renderWishlistDrawer() {
    var body = document.getElementById('wishlist-panel-body');
    if (!body) return;
    var items = getWishlist();

    if (items.length === 0) {
      body.innerHTML =
        '<div class="wishlist-empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '<p>Your wishlist is empty.</p>' +
          '<a href="/collections/all" class="btn-primary" style="display:inline-block;margin-top:1rem">Browse products</a>' +
        '</div>';
      return;
    }

    body.innerHTML = items.map(function (item) {
      return '<div class="wishlist-item" data-wishlist-item="' + item.productId + '">' +
        (item.image ? '<a href="' + item.url + '" class="wishlist-item-img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>' : '') +
        '<div class="wishlist-item-info">' +
          '<a href="' + item.url + '" class="wishlist-item-title">' + item.title + '</a>' +
          '<p class="wishlist-item-price">' + item.price + '</p>' +
          '<a href="' + item.url + '" class="wishlist-item-view">View product →</a>' +
        '</div>' +
        '<button class="wishlist-item-remove" data-remove-wishlist="' + item.productId + '" aria-label="Remove from wishlist">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>';
    }).join('');
  }

  function openWishlistDrawer() {
    buildWishlistDrawer();
    renderWishlistDrawer();
    var drawer = document.getElementById('wishlist-drawer');
    if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }

  function closeWishlistDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (drawer) { drawer.classList.remove('open'); document.body.style.overflow = ''; }
  }

  function initWishlistDrawer() {
    // Header heart icon opens the drawer
    on(document, 'click', function (e) {
      var link = e.target.closest('a[href*="wishlist"]');
      if (!link) return;
      e.preventDefault();
      openWishlistDrawer();
    });

    // Remove from drawer
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-remove-wishlist]');
      if (!btn) return;
      var productId = btn.dataset.removeWishlist;
      saveWishlist(getWishlist().filter(function (i) { return i.productId !== productId; }));
      qsa('[data-wishlist-toggle="' + productId + '"]').forEach(function (b) { b.classList.remove('wishlisted'); });
      renderWishlistDrawer();
      showToast('Removed from wishlist', 'success');
    });
  }

  /* =====================================================
     COLLECTION FILTER LINKS (native URL navigation)
     ===================================================== */
  function initCollectionSort() {
    var sortEl = qs('.collection-sort');
    if (!sortEl) return;
    on(sortEl, 'change', function () {
      var url = new URL(window.location.href);
      if (sortEl.value) {
        url.searchParams.set('sort_by', sortEl.value);
      } else {
        url.searchParams.delete('sort_by');
      }
      window.location.href = url.toString();
    });
  }

  /* =====================================================
     STAGGER ANIMATION ON PRODUCT CARDS
     ===================================================== */
  function initProductCardStagger() {
    qsa('.product-card').forEach(function (card, i) {
      card.style.animationDelay = (i * 0.06) + 's';
    });
  }

  /* =====================================================
     INIT
     ===================================================== */
  function initLocaleSwitcher() {
    qsa('.locale-selector-wrapper').forEach(function(wrapper) {
      var toggle = wrapper.querySelector('.locale-toggle');
      if (!toggle) return;
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = wrapper.classList.contains('open');
        qsa('.locale-selector-wrapper.open').forEach(function(w) { w.classList.remove('open'); });
        if (!isOpen) wrapper.classList.add('open');
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
    document.addEventListener('click', function() {
      qsa('.locale-selector-wrapper.open').forEach(function(w) {
        w.classList.remove('open');
        var t = w.querySelector('.locale-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initSubscribePopup() {
    var popup    = qs('#subscribe-popup');
    var closeBtn = qs('#subscribe-popup-close');
    var backdrop = qs('.subscribe-popup-backdrop');
    var form     = qs('#subscribe-popup-form');
    if (!popup) return;

    var STORAGE_KEY = 'roccope_popup_dismissed';
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored && Date.now() < parseInt(stored, 10)) return;

    function openPopup() {
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    function closePopup(days) {
      popup.style.display = 'none';
      document.body.style.overflow = '';
      var expiry = Date.now() + (days || 7) * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(expiry));
    }

    setTimeout(openPopup, 3000);

    if (closeBtn) closeBtn.addEventListener('click', function() { closePopup(7); });
    if (backdrop) backdrop.addEventListener('click', function() { closePopup(7); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.style.display === 'flex') closePopup(7);
    });
    if (form) form.addEventListener('submit', function() { closePopup(365); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initToasts();
    initHeader();
    initMobileMenu();
    initSearchModal();
    initHeroSlider();
    initReveal();
    initProductGallery();
    initQuantitySteppers();
    initProductTabs();
    initFAQ();
    initNewsletter();
    initQuickAdd();
    initProductAddToCart();
    initVariantSelector();
    initCartPage();
    initDiscountCode();
    initLocaleSwitcher();
    initSubscribePopup();
    initWishlistButtons();
    initWishlistDrawer();
    initCollectionSort();
    initProductCardStagger();
    fetchCartCount();
  });

})();
